import { useEffect, useState } from "react"
import { useFormik } from "formik"
import * as yup from "yup"
import { useLoginApiMutation } from "./Services/loginService"
import { useTranslation } from "react-i18next"
import { setCredentials } from "./authSlice"
import { useDispatch } from "react-redux"
import i18n from "../../i18n"
import { setLocationModal } from "../Common/commonSlice"

export const useLogin = () => {
    const phoneRegex: any =
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

    const alpanumericRegex = /^[A-Z0-9]{6}$/

    const validationSchema = yup.object({
        name: yup.string().required("Technician Name is required"),
        phone: yup
            .string()
            .required("Technician Number is required")
            .label("Mobile Number")
            .max(10, "Mobile number should be only 10 digits")
            .matches(phoneRegex, "Mobile number is not valid"),
        vendor_code: yup
            .string()
            .trim()
            .transform((val) => (typeof val === 'string' ? val.toUpperCase() : val))
            .required('Unique code is required')
            .matches(
                alpanumericRegex,
                'Must be exactly 6 characters, uppercase letters and numbers only'
            ),
    })

    const [loginApi, { error: loginError, isLoading: isLoginLoading, isError: isLoginError }] = useLoginApiMutation()

    const dispatch = useDispatch()

    const { t: translate } = useTranslation()

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        localStorage.setItem("lang", "en")
    }, [])

    const formik = useFormik({
        initialValues: {
            vendor_code: "",
            name: "",
            phone: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const latitude: any = localStorage.getItem("latitude")
            const longitude: any = localStorage.getItem("longitude")

            const payload = {
                ...(latitude && { latitude: parseFloat(latitude) }),
                ...(longitude && { longitude: parseFloat(longitude) }),
                ...values,
                vendor_code: values.vendor_code.toUpperCase()
            }

            latitude && longitude ? loginApi(payload)
                .unwrap()
                .then((response: any) => {
                    setLoader(true)
                    if (response.meta.status_code === 200) {
                        const data: any = response?.data
                        const encodedData = window.btoa(JSON.stringify(data))
                        const encodedkey = window.btoa("user_info")
                        localStorage.setItem(`${encodedkey}`, encodedData)
                        localStorage.setItem("currentStep", "1")
                        i18n.changeLanguage("en")
                        dispatch(setCredentials({ token: data?.access_token }))
                    }
                })
                .catch(() => {
                    setLoader(true)
                }) :
                dispatch(setLocationModal({ locationModal: true }))
        },
    })

    return {
        states: {
            isLoginLoading,
            loginError,
            isLoginError,
            formik,
            loader
        },
        functions: {
            translate
        }
    }
}
